import 'script-loader!jquery';
import '../scss/entry.scss';

jQuery(document).ready(function($) {

});